import { z } from "zod";
import { dmaFormulationDtoSchema } from "../dma-formulation/dma-formulation.schema";
export const dmaCreateValidationFormulationDtoSchema = z
    .object({
    name: z.string(),
    description: z.string(),
})
    .and(dmaFormulationDtoSchema);
